import {
  OBSERVADOR_INICIALITZAR,
  OBTENIR_DADES_OBSERVADOR,
  ESBORRAR_OBSERVADOR_SELECCIONAT
} from "../../../actions/actionTypes";

const ESTAT_INICIAL = {
  carrer: null,
  codiINE: null,
  codiPostal: null,
  nom: null,
  cognom1: null,
  cognom2: null,
  comarca: null,
  expert: null,
  municipi: null,
  numero: null,
  pis: null,
  porta: null,
  permisMostrarNom: null,
  codi: null,
  telefon: null,
  usuariCorreuElectronic: null,
  usuariActiu: null,
  usuariNom: null,
  usuariRol: null,
  dataAlta: null,
  dataBaixa: null,
  foto: null
};

const originals = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case OBSERVADOR_INICIALITZAR:
    case `${OBTENIR_DADES_OBSERVADOR}_EN_CURS`:
    case `${OBTENIR_DADES_OBSERVADOR}_ERROR`:
    case ESBORRAR_OBSERVADOR_SELECCIONAT:
      return ESTAT_INICIAL;

    case `${OBTENIR_DADES_OBSERVADOR}_SUCCESS`:
      return action.payload[action.payload[Object.keys(action.payload)[0]].key];

    default:
      return state;
  }
};

export default originals;
